import { render, staticRenderFns } from "./Maddeler.vue?vue&type=template&id=5766054d&scoped=true"
import script from "./Maddeler.vue?vue&type=script&lang=js"
export * from "./Maddeler.vue?vue&type=script&lang=js"
import style0 from "./Maddeler.vue?vue&type=style&index=0&id=5766054d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5766054d",
  null
  
)

export default component.exports